import axios from 'axios';

const useSaveQuantities = () => {
  return async ({ estimateId, quantities }) => {
    if (!estimateId) throw new Error('Estimate ID is required.');

    const quantityMap = {
      'Natural Gas': 1,
      NGL: 2,
      Hydrogen: 3,
    };

    const pipeSizes = [
      '2.875',
      '3.5',
      '4.5',
      '6.625',
      '8.625',
      '10.75',
      '12.75',
      '16',
      '18',
      '20',
      '24',
      '26',
      '30',
      '36',
      '42',
      '48',
    ];

    const payload = quantities.map((q, i) => {
      let quantityValue;

      if (pipeSizes.includes(q.quantity)) {
        quantityValue = q.quantity;
      } else if (isNaN(Number(q.quantity))) {
        quantityValue = quantityMap[q.quantity] ?? null;
      } else {
        quantityValue = Number(q.quantity);
      }

      return {
        estimateId,
        rowNumber: q.rowNumber ?? i + 1,
        category: q.category || '',
        type: q.type || '',
        quantity: quantityValue,
        units: q.units || '',
        notes: q.notes || '',
        dataSource: q.dataSource || '',
        status: q.status || '',
      };
    });

    try {
      const response = await axios.put(`/api/PipelinePricing/pipeline/update-quantities/${estimateId}`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response;
    } catch (err) {
      console.error('Axios PUT error:', err);
      throw err;
    }
  };
};

export default useSaveQuantities;
